@if(!(dashboardS.onboardingSkipped$|async))
{
<app-stepsOnboarding></app-stepsOnboarding>
}@else {
<app-dashboardOfficial [authenticator]="[ 'OFFICIAL']"></app-dashboardOfficial>
<app-dashboardGroupAssignor [authenticator]="[ 'GROUP_ASSIGNOR','SUB_ASSIGNOR','ADMIN']"></app-dashboardGroupAssignor>
}
